import _styled from "styled-components";
var _excluded = ["className", "style", "isDisabled", "isLoading", "isOpen", "getLabelProps", "getToggleButtonProps", "targetProps", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-helpers';
import ProgressRing from '@adsk/alloy-progress-ring';
import theme, { getInteractiveStyles } from '@adsk/alloy-theme';
import ToggleButton from './ToggleButton';

var ControlLabel = function ControlLabel(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      getLabelProps = _ref.getLabelProps,
      getToggleButtonProps = _ref.getToggleButtonProps,
      targetProps = _ref.targetProps,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(_StyledLabel, _extends({
    ref: targetProps.ref,
    "data-testid": 'Dropdown__control',
    className: className
  }, getLabelProps === null || getLabelProps === void 0 ? void 0 : getLabelProps(), props, {
    $_css: [_objectSpread(_objectSpread(_objectSpread({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1px 12px',
      border: "1px solid ".concat(theme.colors.charcoal400),
      borderRadius: 2,
      cursor: 'pointer'
    }, getInteractiveStyles(isDisabled)), isOpen && {
      borderColor: theme.colors.adskBlue500,
      boxShadow: "0 0 0 2px ".concat(theme.colors.focusHalo),
      '&:hover': {
        boxShadow: "0 0 0 2px ".concat(theme.colors.focusHalo)
      }
    }), isDisabled && {
      backgroundColor: theme.colors.charcoal050,
      borderColor: theme.colors.charcoal200,
      cursor: 'default',
      pointerEvents: 'none'
    }), style]
  }), children, isLoading && /*#__PURE__*/React.createElement(ProgressRing, {
    size: ProgressRing.SIZES.XSMALL,
    style: {
      marginLeft: 8
    }
  }), /*#__PURE__*/React.createElement(ToggleButton, {
    getToggleButtonProps: getToggleButtonProps,
    isOpen: isOpen,
    style: {
      marginLeft: 8,
      marginRight: 4
    }
  }));
};

ControlLabel.displayName = 'ControlLabel';
ControlLabel.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,

  /** Class applied to the root element */
  className: PropTypes.string,

  /** Toggle disabled state */
  isDisabled: PropTypes.bool,

  /** Toggle loading state */
  isLoading: PropTypes.bool,

  /** Whether Dropdown menu is open */
  isOpen: PropTypes.bool.isRequired,

  /** Function to get props for the menu toggle button */
  getToggleButtonProps: PropTypes.func.isRequired,

  /** Function to get props for the label surrounding the control */
  getLabelProps: PropTypes.func.isRequired,

  /** targetProps returned from useDropdown hook */
  targetProps: PropTypes.shape({
    ref: PropTypes.any
  }).isRequired,

  /** The content of te ControlContainer */
  children: PropTypes.node
};
export default ControlLabel;

var _StyledLabel = _styled("label").withConfig({
  displayName: "ControlLabel___StyledLabel",
  componentId: "sc-1or6c9b-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=ControlLabel.js.map